import React, { Component } from 'react'
import { Field, reduxForm, InjectedFormProps } from 'redux-form'

interface Props {
  ofacScore?: number
  adminVerifications?: {
    id?: string
    status?: string
    taskType?: string
  }[]
}

interface FormProps {
  accept: boolean
}

export class OfacNoteForm extends Component<
  Props & InjectedFormProps<FormProps, Props>
> {
  render() {
    const { adminVerifications, ofacScore } = this.props

    const ofacTasks =
      adminVerifications &&
      adminVerifications.filter((task) => {
        return task.taskType === 'REVIEW_OFAC'
      })
    const ofacTask = (ofacTasks && ofacTasks[0]) || null
    const renderOfacNote = ofacTask && ofacTask.status === 'PENDING'

    const noteInput = (
      <form className="form" name="underwritingRuleForm">
        <div className="loan-buttons">
          <Field
            type="text"
            component="input"
            className="admin-note"
            name="adminNote"
            placeholder="OFAC Note"
          />
          <Field type="hidden" component="input" name="accept" />
          <Field type="hidden" component="input" name="taskId" />
          <button
            type="submit"
            onClick={() => this.props.change('accept', false)}
            disabled={false}
            className="button button--secondary"
          >
            Reject
          </button>
          <button
            type="submit"
            onClick={() => this.props.change('accept', true)}
            disabled={false}
            className="button __form__button--submit button--primary"
          >
            Accept
          </button>
        </div>
      </form>
    )
    return (
      <li>
        OFAC Value
        <span className="summary-value">{ofacScore}</span>
        {renderOfacNote ? noteInput : null}
      </li>
    )
  }
}
export default reduxForm<FormProps, Props>({
  form: 'underwritingOfacNoteForm',
  enableReinitialize: true,
  destroyOnUnmount: true,
})(OfacNoteForm)
